<template>
  <div class="align direction">
    <div v-if="$store.state.userLevel===false||typeof($store.state.userLevel)==='number'">
      <DredgeVipDefault v-if="$store.state.userLevel" v-bind="$attrs"></DredgeVipDefault>
      <LoginView v-else></LoginView>
    </div>
    <LoginView v-else></LoginView>
  </div>
</template>

<script>
  import LoginView from './LoginView'
  export default {
    components: {
      LoginView,
    },
  }
</script>
